import * as _ from './utils';

export var Options = {
	autofitBounds: true,
	autohide: !L.Browser.mobile,
	autohideMarker: true,
	almostover: true,
	altitude: true,
	collapsed: false,
	detached: true,
	distance: true,
	distanceFactor: 1,
	distanceMarkers: false,
	decimalsX: 2,
	decimalsY: 0,
	dragging: !L.Browser.mobile,
	downloadLink: 'link',
	elevationDiv: "#elevation-div",
	followMarker: true,
	forceAxisBounds: false,
	height: 200,
	heightFactor: 1,
	imperial: false,
	interpolation: "curveLinear",
	lazyLoadJS: true,
	legend: true,
	loadData: {
		defer: false,
		lazy: false,
	},
	margins: {
		top: 30,
		right: 30,
		bottom: 30,
		left: 40
	},
	marker: 'elevation-line',
	markerIcon: L.divIcon({
		className: 'elevation-position-marker',
		html: '<i class="elevation-position-icon"></i>',
		iconSize: [32, 32],
		iconAnchor: [16, 16],
	}),
	placeholder: false,
	position: "topright",
	polyline: {
		className: 'elevation-polyline',
		color: '#000',
		opacity: 0.75,
		weight: 5,
		lineCap: 'round'
	},
	polylineSegments: {
		className: 'elevation-polyline-segments',
		color: '#F00',
		interactive: false,
	},
	preferCanvas: false,
	reverseCoords: false,
	ruler: true,
	skipNullZCoords: false,
	theme: "lightblue-theme",
	responsive: true,
	summary: 'inline',
	slope: false,
	speed: false,
	sLimit: undefined,
	time: false,
	timeFactor: 3600,
	timeFormat: false,
	sDeltaMax: undefined,
	sInterpolation: "curveStepAfter",
	sRange: undefined,
	width: 600,
	waypoints: true,
	wptIcons: {
		'': L.divIcon({
			className: 'elevation-waypoint-marker',
			html: '<i class="elevation-waypoint-icon"></i>',
			iconSize: [30, 30],
			iconAnchor: [8, 30],
		}),
	},
	wptLabels: true,
	xAttr: "dist",
	xLabel: "km",
	xTicks: undefined,
	yAttr: "z",
	yAxisMax: undefined,
	yAxisMin: undefined,
	yLabel: "m",
	yTicks: undefined,
	zFollow: false,
	zooming: !L.Browser.Mobile,
};
